/**
 * ManualForm — formulário de item manual (descrição, qt, dimensões, módulo com
 * opção "Novo módulo", categoria). Compartilhado entre o Editor (lista ao vivo)
 * e a Lista salva (histórico).
 */
import React, { useMemo } from "react";

import { DINABOX_CATEGORIES } from "./lib/parseProjeto";
import { NOVO_MODULO, moduloSemCodigo } from "./lib/documento";
import { Field, FieldLabel, LinhaQtDim } from "./styles";

export function formManualInicial() {
  return { nome: "", quantidade: 1, dimensoes: "", moduleId: "", categoria: "Outros", novoModulo: "" };
}

export default function ManualForm({ form, setForm, modulos }) {
  const cats = useMemo(() => Array.from(new Set(DINABOX_CATEGORIES)), []);
  const ehNovo = form.moduleId === NOVO_MODULO;
  return (
    <div>
      <Field>
        <FieldLabel>Descrição</FieldLabel>
        <input
          className="input"
          placeholder="Ex.: Parafuso 4,5x40 chipboard"
          value={form.nome}
          onChange={(e) => setForm((f) => ({ ...f, nome: e.target.value }))}
          autoFocus
        />
      </Field>
      <LinhaQtDim>
        <Field>
          <FieldLabel>Quantidade</FieldLabel>
          <input
            className="input" type="number" min="0" step="any"
            value={form.quantidade}
            onChange={(e) => setForm((f) => ({ ...f, quantidade: e.target.value }))}
          />
        </Field>
        <Field>
          <FieldLabel>Dimensões</FieldLabel>
          <input
            className="input" placeholder="Ex.: 4,5 x 40 mm"
            value={form.dimensoes}
            onChange={(e) => setForm((f) => ({ ...f, dimensoes: e.target.value }))}
          />
        </Field>
      </LinhaQtDim>
      <Field>
        <FieldLabel>Módulo</FieldLabel>
        <select
          className="input"
          value={form.moduleId}
          onChange={(e) => setForm((f) => ({ ...f, moduleId: e.target.value }))}
        >
          {modulos.length === 0 ? (
            <option value="">Dispositivos de montagem</option>
          ) : (
            modulos.map((m) => (
              <option key={m.moduleId} value={m.moduleId}>
                {moduloSemCodigo(m.moduleId) ? m.moduleName : `${m.moduleId} — ${m.moduleName}`}
              </option>
            ))
          )}
          <option value={NOVO_MODULO}>➕ Novo módulo…</option>
        </select>
      </Field>
      {ehNovo ? (
        <Field>
          <FieldLabel>Nome do novo módulo</FieldLabel>
          <input
            className="input"
            placeholder="Ex.: Iluminação, Rodapés, Acessórios…"
            value={form.novoModulo}
            onChange={(e) => setForm((f) => ({ ...f, novoModulo: e.target.value }))}
            autoFocus
          />
        </Field>
      ) : null}
      <Field>
        <FieldLabel>Categoria</FieldLabel>
        <select
          className="input"
          value={form.categoria}
          onChange={(e) => setForm((f) => ({ ...f, categoria: e.target.value }))}
        >
          {cats.map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </Field>
    </div>
  );
}
